import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CommentSection = ({ articleId }) => {
  const [comments, setComments] = useState([
    {
      id: 1,
      author: {
        name: "Jennifer Martinez",
        avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face"
      },
      content: "This guide was incredibly helpful! I followed the recommendations for my 16-year-old brother and got him the SteelSeries headset. He absolutely loves it and his gaming performance has improved noticeably.",
      timestamp: new Date(Date.now() - 86400000),
      likes: 12,
      isLiked: false
    },
    {
      id: 2,
      author: {
        name: "Mike Chen",
        avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face"
      },
      content: "Great article! The budget breakdown was especially useful. I was able to find some amazing deals on the recommended gaming keyboard. The RGB lighting is a huge hit with my son.",
      timestamp: new Date(Date.now() - 172800000),
      likes: 8,
      isLiked: true
    },
    {
      id: 3,
      author: {
        name: "Sarah Williams",
        avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face"
      },
      content: "The expert tips section saved me from making a costly mistake. I almost bought a headset that wouldn\'t work with my daughter\'s gaming setup. Thank you for the detailed compatibility information!",
      timestamp: new Date(Date.now() - 259200000),
      likes: 15,
      isLiked: false
    }
  ]);

  const [newComment, setNewComment] = useState('');
  const [showCommentForm, setShowCommentForm] = useState(false);

  const handleSubmitComment = (e) => {
    e.preventDefault();
    if (!newComment.trim()) return;

    const comment = {
      id: comments.length + 1,
      author: {
        name: "You",
        avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face"
      },
      content: newComment,
      timestamp: new Date(),
      likes: 0,
      isLiked: false
    };

    setComments(prev => [comment, ...prev]);
    setNewComment('');
    setShowCommentForm(false);
  };

  const handleLikeComment = (commentId) => {
    setComments(prev => prev.map(comment => 
      comment.id === commentId 
        ? { 
            ...comment, 
            isLiked: !comment.isLiked,
            likes: comment.isLiked ? comment.likes - 1 : comment.likes + 1
          }
        : comment
    ));
  };

  const formatTimestamp = (timestamp) => {
    const now = new Date();
    const diff = now - timestamp;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    
    if (days === 0) return 'Today';
    if (days === 1) return 'Yesterday';
    if (days < 7) return `${days} days ago`;
    
    return timestamp.toLocaleDateString();
  };

  return (
    <div className="bg-white rounded-2xl shadow-soft border border-accent-100 p-8 my-12">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-2">
          <Icon name="MessageCircle" size={20} className="text-primary" />
          <h3 className="font-heading font-bold text-xl text-accent-800">
            Comments ({comments.length})
          </h3>
        </div>
        
        <Button
          variant="primary"
          size="sm"
          onClick={() => setShowCommentForm(!showCommentForm)}
          iconName="Plus"
          iconPosition="left"
        >
          Add Comment
        </Button>
      </div>

      {/* Comment Form */}
      {showCommentForm && (
        <form onSubmit={handleSubmitComment} className="mb-8 p-4 bg-accent-50 rounded-xl">
          <textarea
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            placeholder="Share your thoughts or experience..."
            rows={4}
            className="w-full p-3 border border-accent-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
          />
          <div className="flex items-center justify-between mt-3">
            <span className="text-sm text-accent-600">
              {newComment.length}/500 characters
            </span>
            <div className="flex items-center space-x-2">
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => setShowCommentForm(false)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="primary"
                size="sm"
                disabled={!newComment.trim()}
              >
                Post Comment
              </Button>
            </div>
          </div>
        </form>
      )}

      {/* Comments List */}
      <div className="space-y-6">
        {comments.map((comment) => (
          <div key={comment.id} className="flex items-start space-x-4">
            <img
              src={comment.author.avatar}
              alt={comment.author.name}
              className="w-10 h-10 rounded-full object-cover flex-shrink-0"
            />
            
            <div className="flex-1">
              <div className="flex items-center space-x-2 mb-2">
                <span className="font-medium text-accent-800">
                  {comment.author.name}
                </span>
                <span className="text-sm text-accent-500">
                  {formatTimestamp(comment.timestamp)}
                </span>
              </div>
              
              <p className="text-accent-700 leading-relaxed mb-3">
                {comment.content}
              </p>
              
              <div className="flex items-center space-x-4">
                <button
                  onClick={() => handleLikeComment(comment.id)}
                  className={`flex items-center space-x-1 text-sm transition-colors ${
                    comment.isLiked 
                      ? 'text-primary' :'text-accent-500 hover:text-primary'
                  }`}
                >
                  <Icon 
                    name={comment.isLiked ? "Heart" : "Heart"} 
                    size={16} 
                    className={comment.isLiked ? "fill-current" : ""}
                  />
                  <span>{comment.likes}</span>
                </button>
                
                <button className="text-sm text-accent-500 hover:text-primary transition-colors">
                  Reply
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Load More Comments */}
      {comments.length > 0 && (
        <div className="text-center mt-8">
          <Button
            variant="ghost"
            iconName="ChevronDown"
            iconPosition="right"
          >
            Load More Comments
          </Button>
        </div>
      )}
    </div>
  );
};

export default CommentSection;